import { register, getPrefix, getCookie } from '../../../Utils'
import citiesToCountries from './CitiesToCountries.json'
import countryCodeToCountryname from './countryCodeToCountryname.json'
import countriesToUrl from './CountriesToUrl.json'

/*
The provided JSON (CitiesToCountries.json) is a snapshot from 08/2022.
It was build by using the package moment-timezone and extracted from moment-timezone/data/meta/latest.json
To update the data in the future:
- add moment-timezone library,
- import { countries, zones } from 'moment-timezone/data/meta/latest.json'
- run the commented-out code from below and save as new JSON.
*/

const LanguageSuggestion = el => {
  let pageLanguage = document.querySelector('html').getAttribute('lang')
  const cookieName = 'alternative_country_selection'

  if (pageLanguage && !getCookie(cookieName)) {
    const prefix = getPrefix(el)
    const currentUrl = el.dataset.siteUrl
    const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const currentCity = currentTimeZone.split('/')[1]
    const countryContainer = el.querySelector(`.${prefix}user-country-code`)
    const urlContainer = el.querySelector(`.${prefix}url-suggestion`)
    const closeButton = el.querySelector(`.${prefix}close-button`)

    pageLanguage = pageLanguage.includes('-') ? pageLanguage.split('-')[1].toUpperCase() : pageLanguage.toUpperCase()

    if (citiesToCountries[currentCity]) {
      const userLanguage = citiesToCountries[currentCity]
      const userCountry = countryCodeToCountryname[userLanguage]

      if ((pageLanguage !== userLanguage && currentUrl !== 'https://www.geistlich-pharma.com/') || (countriesToUrl.hasOwnProperty(userLanguage) && currentUrl === 'https://www.geistlich-pharma.com/')) {
        el.classList.add(`${prefix}is--visible`)
        countryContainer.innerText = userCountry

        closeButton.addEventListener('click', e => {
          // set cookie?
          const expiryDate = new Date(new Date().setMonth(new Date().getMonth() + 1))
          document.cookie = `${cookieName}=true; expires=${expiryDate}; path=/; SameSite=lax; Secure`
          el.remove()
        })

        if (countriesToUrl.hasOwnProperty(userLanguage)) {
          urlContainer.href = countriesToUrl[userLanguage].url
          urlContainer.innerText = countriesToUrl[userLanguage].linkText
        }
      }
    }
  }

  // Use this to generate new JSON
  // const timeZoneCityToCountry = {}
  // Object.keys(zones).forEach(zone => {
  //   const cityArr = zone.split('/')
  //   const city = cityArr[cityArr.length - 1]
  //   timeZoneCityToCountry[city] = zones[zone].countries[0]
  // })
}

register('LanguageSuggestion', LanguageSuggestion)
